/* eslint-disable react/prop-types */ // TODO: add props
import ChunkCarousel from '../../../ChunkCarousel';
import ShareLink from 'edrolo/components/common/ShareLink';

export const EmptyLesson = ({ lesson, classId }) => {
  return (
    <div className="lesson-v2">
      <div key={lesson.get('id')} className="lesson-body">
        <h1>
          {lesson.get('title')} &nbsp;
          <ShareLink
            title="To share this lesson, copy and paste this link:"
            model="lesson"
            objectId={lesson.get('id')}
            classId={classId}
            shareType="lesson"
            origin="chunkview_v2"
          >
            <button className="share-link">
              <i className="icon-share-square-o" />
            </button>
          </ShareLink>
        </h1>
        <ChunkCarousel lesson={lesson} />
      </div>
    </div>
  );
};
